/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _6 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>6 - Работа с Git из консоли</h2>
    <p className={styles.description}>
      С Git можно работать не только из программ с графическим интерфейсом, но и из консоли. В веб-разработке понимание
      Git и умение работы с Git из консоли чаще всего является требованием.
    </p>
    <p className={styles.description}>
      Таблица базовых команд для работы с git из консоли, при условии что git есть в системе.
    </p>
    <table className={styles.table}>
      <thead>
        <tr>
          <th>Синтаксис</th>
          <th>Описание</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <code className={styles.code}>git clone [params]</code>
          </td>
          <td>Клонирует удаленный репозиторий на компьютер автоматически связывая его с локальной версией.</td>
        </tr>
        <tr>
          <td>
            <code className={styles.code}>git status</code>
          </td>
          <td>
            Проверяет наличие изменений в состоянии файлов проекта со времени последнего коммита. При наличии изменений
            выведет в консоль информацию о файлах в которых есть изменения.
          </td>
        </tr>
        <tr>
          <td>
            <code className={styles.code}>git add [file-name или .]</code>
          </td>
          <td>
            Чтобы сообщить Git о необходимости начать отслеживать изменения, внесенные в файлы, сначала нужно добавить
            их в <code className={styles.code}>staging area</code>, используя{' '}
            <code className={styles.code}>git add</code>. При выполнении <code className={styles.code}>git add .</code>{' '}
            точка обозначает добавление всех изменений которые есть.
          </td>
        </tr>
        <tr>
          <td>
            <code className={styles.code}>git reset [filename]</code>
          </td>
          <td>Используется для удаления файла из под версионного контроля.</td>
        </tr>
        <tr>
          <td>
            <code className={styles.code}>git commit -m "комментарий"</code>
          </td>
          <td>
            Создает слепок текущего состояния файлов которые находятся под версионным контролем. Принято описывать
            каждый commit кратким ясным комментарием о внесенных изменениях. Количество коммитов не ограничено. Таким
            образом, если нам когда-либо понадобится вернуться к прошлой версии проекта, мы сможем откатить проект до
            определенного коммита.
          </td>
        </tr>
        <tr>
          <td>
            <code className={styles.code}>git log</code>
          </td>
          <td>
            Выводит журнал изменений в репозитории, как список всех коммитов которые были сделаны, в хронологическом
            порядке.
          </td>
        </tr>
        <tr>
          <td>
            <code className={styles.code}>git push</code>
          </td>
          <td>
            Отправляет все сохраненные в коммитах изменения из локального репозитория на удаленный. При выполнении{' '}
            <code className={styles.code}>git push -u origin master</code>, флаг <code className={styles.code}>-u</code>{' '}
            говорит Git запомнить куда мы пушим (на удаленный репозиторий, <code className={styles.code}>origin</code>,
            в ветку <code className={styles.code}>master</code>). После чего достаточно будет выполнять просто{' '}
            <code className={styles.code}>git push</code>.
          </td>
        </tr>
        <tr>
          <td>
            <code className={styles.code}>git pull</code>
          </td>
          <td>Забирает последние изменения с удаленного репозитория в локальный, при условии что они уже связаны.</td>
        </tr>
        <tr>
          <td>
            <code className={styles.code}>git init</code>
          </td>
          <td>
            Инициализирует создание локального репозитория в текущей папке. Создается скрытая папка{' '}
            <code className={styles.code}>.git</code> в которой хранится служебная информация о локальном репозитории.
          </td>
        </tr>
        <tr>
          <td>
            <code className={styles.code}>git remote add origin [repo-url]</code>
          </td>
          <td>
            Связывает удаленный репозиторий с локальным репозиторием по <code className={styles.code}>url</code>. Нужен
            существующий удаленный репозиторий. После выполнения комманды можно будет пушить изменения на удаленный
            репозиторий.
          </td>
        </tr>
      </tbody>
    </table>
  </section>
))
